<span
  class="input-message-error"
  *ngIf="isInvalid()"
>
{{ message() }}
</span>
